import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import downloadIcon from 'images/download-arrow.svg';

/* Need to add functionality to work out how many download buttons are available */

const Container = styled.div.attrs({ className: 'download-chart-container' })`
  z-index: 10;
  width: 60px;
  height: 60px;
  position: relative;
  > div:last-child{
    > div{
      right: 0;
      bottom: 0;
      transition: right 0.5s, bottom 0.5s;
    }
  }

  &:hover, &:focus-within{
    > div:first-child{
      background-color: ${(props) => props.theme.brandDark};
      filter: none;
    }
    > div:last-child{
      > div:first-child{
        right: 60px;
      }
      > div:last-child:not(:first-child){
        bottom: -60px;
      }
    }
  }
  &::before {
    content: '';
    width: 60px;
    height: 60px;
    background-color: white;
    position: absolute;
    z-index: 1;
    border-bottom: 1px solid ${(props) => props.theme.lightGrey};
  }
`;

export const DownloadIcon = styled.div`
  display: block;
  height: 60px;
  width: 60px;
  cursor: pointer;
  background-image: url(${downloadIcon});
  background-size: 30px;
  background-position: center;
  padding: 0;
  z-index: 10;
  overflow: hidden;
  position: absolute;
  filter: invert(1);
  border-left: none !important;
`;

const DownloadChildren = styled.div`
  text-align: right;
  left: 0;
  top: 0;
  height: 100%;
  width: 100%;
  z-index: 9;
  > div{
    position: absolute;
  }
  button {
    width: 60px;
    height: 60px;
    padding: 20px 10px !important;
    border-left: none !important;
    color: #ffffff !important;
    background-color: ${(props) => props.theme.brandPurple} !important;
    &:hover, &:focus-visible{
      background-color: ${(props) => props.theme.brandDark} !important;
    }
  }
`;

const DownloadContainer = (props) => (
  <Container>
    <DownloadIcon title="Download Chart" />
    <DownloadChildren>
      {props.children}
    </DownloadChildren>
  </Container>
);


DownloadContainer.propTypes = {
  children: PropTypes.node,
};

export default DownloadContainer;



// WEBPACK FOOTER //
// ./app/components/Chart/DownloadButtons/downloadContainer.js